import React, {useContext} from 'react';
import {Arguments} from '../common/Arguments';
import {Col, Form, Input, InputNumber, message, Row, Select} from 'antd';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {convertData, PostApiMethod, PostToJava} from '../common/ApiMethod';
import {sideMenuContext} from '../../../router/IndexRouter';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';
import '../../../components/sandbox/index.css';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const EditUser = () => {
		const [form] = Form.useForm();
		const {currentItem} = useContext(sideMenuContext);
		const userInfoApi = Arguments.host + '/society_organization/policy/api!addUser.do';
		const organizationInfoApi = Arguments.host + '/society_organization/society/api!addSocietyInformation.do';
		const onFinish = (data) => {
			// 更新 user_info 表中数据
			const userData = {
				...currentItem, ...data,
			};
			PostApiMethod(userInfoApi, userData);
			setTimeout(() => {
				// 更新 organization_info 表中数据
				// 为了避免出现两次成功提醒，并尽可能减少对其他程序的影响，此处不使用 PostApiMethod
				const ObjData = convertData(userData);
				PostToJava(organizationInfoApi, ObjData).then(res => {
					if (res?.data.code === 1 || res?.data.code === '1') {
						// console.log("向 organization_info 表中新增数据成功");
					} else {
						// console.log("向 organization_info 表中新增数据失败：" + res.data.result.msg)
					}
				}).catch(error => {
					// console.log("error   ", error)
					message.error('新增数据失败');
				});
			}, 500);
		};

		return (
			<Form
				{...layout}
				form={form}
				name="control-hooks"
				onFinish={onFinish}
				initialValues={currentItem}
				style={{maxWidth: 1200, marginLeft: 40}}
			>
				<div className="panel panel-default mt-20">
					<div className="panel-header" style={{marginBottom: 20}}>当前用户信息</div>
				</div>

				<Row align="top">
					<Col span={12}>
						<Form.Item name="nickname" label="原登录用户名"
								   rules={[{required: true, validator: validateWhiteSpace}]}>
							<Input disabled={true}/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name="role" label="角色" rules={[{required: true, message: '内容不能为空'}]}>
							<Select>
								<Select.Option value="社会组织管理员">社会组织管理员</Select.Option>
								<Select.Option value="民非组织管理员">民非组织管理员</Select.Option>
							</Select>
						</Form.Item>
					</Col>
				</Row>

				<Row align="top">
					<Col span={12}>
						<Form.Item
							name="phoneNumber" label="手机号"
							rules={[{required: true, validator: validateWhiteSpace}]}>
							<Input/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name="showFlag" label="显示序号" rules={[{required: true, message: '内容不能为空'}]}>
							<InputNumber min={0} style={{width: 150}}/>
						</Form.Item>
					</Col>
				</Row>

				<Form.Item {...tailLayout}>
					<SaveButtonComponent/>
				</Form.Item>
			</Form>
		);
	}
;

export default EditUser;
